import type { PublicNimbusOptions } from '@nimbus/types'
import { useRuntimeConfig } from '#imports'

export const useHeroConfig = (): NonNullable<PublicNimbusOptions['hero']> => {
    const config = useRuntimeConfig()

    return config.public.nimbus.hero as NonNullable<PublicNimbusOptions['hero']>
}
